var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "管理单位信息",
        okText: "确认",
        cancelText: "取消",
        width: "1000px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "单位名称",
                        prop: "name",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "name", $$v)
                          },
                          expression: "formState.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "单位级别",
                        prop: "level",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.level,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "level", $$v)
                          },
                          expression: "formState.level",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "行政区划",
                        prop: "region",
                      },
                    },
                    [
                      _c("a-ext-dist-picker", {
                        model: {
                          value: _vm.formState.region,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "region", $$v)
                          },
                          expression: "formState.region",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "单位地址",
                        prop: "address",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "address", $$v)
                          },
                          expression: "formState.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "职能描述",
                        prop: "remark",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "remark", $$v)
                          },
                          expression: "formState.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }